import { render, staticRenderFns } from "./SP_Applications.vue?vue&type=template&id=09a57669"
import script from "./SP_Applications.vue?vue&type=script&lang=js"
export * from "./SP_Applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports